module.exports = __webpack_public_path__ + "static/media/tiktokDrawerLateral.7df7bdfa.svg";